export default "__VITE_ASSET__DLcYKxHs__"